<template>
    <v-card-title class="black--text">
        <v-row>
            <v-col cols="12" md="6"> 결제금액 </v-col>
            <v-col cols="12" md="6">
                <v-row>
                    <template v-for="item in prices">
                        <v-col cols="12" :key="item.title">
                            <v-row>
                                <v-col cols="auto"> {{ item.title }} </v-col>
                                <v-spacer />
                                <v-col cols="auto"> {{ item.value }} </v-col>
                            </v-row>
                        </v-col>
                    </template>
                    <v-col cols="12">
                        <v-divider />
                    </v-col>
                    <v-col cols="12">
                        <v-row class="primary--text">
                            <v-col cols="auto"> 최종 합계 </v-col>
                            <v-spacer />
                            <v-col cols="auto"> {{ sale.format() }}원 </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card-title>
</template>

<script>
import { initNshopOrder, NshopOrderAider } from "@/store/nshop";

/** @typedef {import('@/store/nshop').NshopOrder} NshopOrder */

export default {
    components: {},
    props: {
        /** @type {import('vue').PropType<NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    computed: {
        count() {
            return this.value.count;
        },
        sum() {
            return NshopOrderAider.calcPriceSum(this.value);
        },
        fee() {
            return NshopOrderAider.calcPriceFee(this.value, this.sum);
        },
        sale() {
            return NshopOrderAider.calcPriceSale(this.value, this.sum, this.fee);
        },
        prices() {
            let prices = [
                {
                    title: "상품권 금액",
                    value: `${this.sum.format()}원 (${this.count}개)`,
                },
            ];

            if (this.fee) {
                prices.push({
                    title: "결제 수수료",
                    value: `${this.fee.format()}원 (3.5%)`,
                });
            }

            return prices;
        },
    },
};
</script>

<style></style>
